<template>
  <div class="">
    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange">
            <span slot="action" slot-scope="text, record">
                <a @click="gotoStatistics(record)">{{text.site_use_count}}</a>
            </span>
    </a-table>
  </div>
</template>

<script>
import API from "./api";
import {changStatus, removeById,orderList} from "../../../utils/utils"

// site_use_count
const columns = [
  {
    title: "客户名称",
    key: "company",
    dataIndex: "company",
  },
  {
    title: "首次触发时间",
    key: "start_time",
    dataIndex: "start_time",
  },
  {
    title: "最后触发时间",
    key: "end_time",
    dataIndex: "end_time",
  },
  {
    title: "观看页数",
    key: "total_page",
    dataIndex: "total_page",
  },
  {
    title: "已观看分类",
    key: "category_text",
    dataIndex: "category_text",
  },
  {
    title: "观看进度",
    key: "guide_text",
    dataIndex: "guide_text",
  },
  {
    title: "观看次数",
    key: "open_num",
    dataIndex: "open_num",
  },


];
export default {
  name: 'index',
  data() {
    return {
      btn_group_name:"",
      btn_name:"",
      loading: true,
      data: [],
      columns,
      name:"",
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
    }
  },
  created() {
     this.$store.state.adminleftnavnum = "/DataStatistics/xinshou"; //设置左侧导航2-2 active
  },
  computed: {
    hasData() {
      return this.data.length > 0;
    },
  },
  methods: {
    handleChange(pagination, filters, sorter) {
    },
    getList(page) {
      API.service.GET_LIST({page: page || 1}).then(res => {
        this.data = res.data.data.info.data
        this.pagination.total=res.data.data.info.total
        this.pagination.pageSize=res.data.data.info.per_page
        this.pagination.current=res.data.data.info.current_page
        this.loading = false
      })
    },
  },
  mounted() {
    this.getList()
  }

}
</script>
<style scoped>
.inputs {display: inline-block;width: 70px}
.search-group {float: right;}
.search-group .ant-input {width: 200px;margin: 0 8px 0 0 ;}
.button-group {float: left;}
#list_order {width: 50px;}
.top .flex{box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
.min_box{width:500px}
.top{margin-bottom: 20px;}
.num{color: #1890ff;}
</style>
